var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.symbol)?_c('svg',{staticClass:"mtx-svg",class:( _obj = {}, _obj[("mtx-icon " + _vm.symbol)] = _vm.icon, _obj ),attrs:{"viewBox":_vm.fill ? '0 0 1 1' : false}},[_c('use',{attrs:{"xlink:href":("#" + _vm.symbol)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }